import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VSheet,
    { staticClass: "treemap" },
    [
      _c(
        "div",
        { staticClass: "text-subtitle ma-2 text-center font-weight-light" },
        [
          _c(
            "div",
            { staticClass: "text-subtitle-2" },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$vuetify.lang.t("$vuetify.dashboard.lowBalanceTitle")
                  ) +
                  " "
              ),
              _c(
                VIcon,
                {
                  directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
                  staticClass: "ma-2 pa-1 rounded",
                  on: {
                    click: function ($event) {
                      _vm.showSettings = true
                    },
                  },
                },
                [_vm._v(" mdi-tune ")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "text-caption" }, [
            _vm._v(
              _vm._s(
                _vm.$vuetify.lang.t("$vuetify.dashboard.lowBalanceCaption")
              )
            ),
          ]),
        ]
      ),
      _c("div", { staticClass: "text-center text-caption mb-2" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.$vuetify.lang.t(
                "$vuetify.dashboard.matchFound",
                _vm.belowThreshold.length
              )
            ) +
            " "
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "d-flex justify-space-between",
          staticStyle: { "overflow-x": "scroll" },
        },
        _vm._l(_vm.belowThreshold, function (product) {
          return _c(
            "div",
            {
              directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
              key: product.id,
              staticClass: "mx-2 pa-2 text-center",
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  return _vm.clickedProduct(product)
                },
              },
            },
            [
              _c(
                VProgressCircular,
                {
                  attrs: {
                    rotate: -90,
                    size: 80,
                    width: 12,
                    value: product.percent,
                    color: "primary",
                  },
                },
                [_vm._v(" " + _vm._s(product.percent) + "% ")]
              ),
              _c("div", { staticClass: "text-caption" }, [
                _vm._v(" " + _vm._s(product.name) + " "),
              ]),
              _c("div", { staticClass: "text-caption" }, [
                _vm._v(
                  " " + _vm._s(_vm._f("formatNumber")(product.balance)) + " "
                ),
              ]),
            ],
            1
          )
        }),
        0
      ),
      _c(
        VDialog,
        {
          staticStyle: { "z-index": "1000" },
          model: {
            value: _vm.showSettings,
            callback: function ($$v) {
              _vm.showSettings = $$v
            },
            expression: "showSettings",
          },
        },
        [
          _c(
            VCard,
            { attrs: { height: "500" } },
            [
              _c(VCardTitle, { staticClass: "justify-end" }, [
                _c(
                  "div",
                  [
                    _c(
                      VBtn,
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function ($event) {
                            _vm.showSettings = null
                          },
                        },
                      },
                      [_c(VIcon, [_vm._v("mdi-close")])],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                VCardText,
                [
                  _c("page-params", {
                    attrs: {
                      pageName: "lowBalanceAlert",
                      vuexName: "lowBalanceSettings",
                      parameters: _vm.parameters,
                    },
                    on: { onLoad: _vm.loadedSavedParams },
                  }),
                  _c(VDivider, { staticClass: "my-4" }),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-space-between my-2" },
                    [
                      _c(VSwitch, {
                        staticClass: "flex-grow-1",
                        attrs: { label: "Hide zero balance" },
                        model: {
                          value: _vm.parameters.hideZero,
                          callback: function ($$v) {
                            _vm.$set(_vm.parameters, "hideZero", $$v)
                          },
                          expression: "parameters.hideZero",
                        },
                      }),
                      _c(VTextField, {
                        staticClass: "flex-shrink-1",
                        attrs: {
                          label: "Threshold",
                          type: "number",
                          max: "100",
                          suffix: "%",
                        },
                        model: {
                          value: _vm.parameters.threshold,
                          callback: function ($$v) {
                            _vm.$set(_vm.parameters, "threshold", $$v)
                          },
                          expression: "parameters.threshold",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("product-select", {
                    key: _vm.ts,
                    staticClass: "mx-2 mb-6",
                    attrs: {
                      required: "",
                      "return-object": "",
                      multiple: true,
                      label: "Choose monitoring products",
                    },
                    model: {
                      value: _vm.parameters.products,
                      callback: function ($$v) {
                        _vm.$set(_vm.parameters, "products", $$v)
                      },
                      expression: "parameters.products",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCardActions,
                { staticClass: "justify-center" },
                [
                  _c(VBtn, { on: { click: _vm.updatedSettings } }, [
                    _vm._v(" Done "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }